export default __webpack_public_path__ + "static/media/5254.12903c6e.png";